import axios from "../../config/axiosConfig";
import { CASH_PAYMENT_REQUEST, CASH_PAYMENT_REQUEST_FAILURE, CREATE_CASH_PAYMENT, DELETE_CASH_PAYMENT, GET_CASH_PAYMENTS, UPDATE_CASH_PAYMENT,
  CASH_PAYMENT_REQUEST_SUCCESS, GET_CASH_PAYMENTS_PAGE } from "../types";

export const getCashPaymentsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_PAYMENT_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/cash-payment/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CASH_PAYMENTS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCashPayments = (include, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/cash-payment/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_CASH_PAYMENTS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getCashPaymentByRange = (billId, from, to, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 

      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/cash-payment/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getCashPaymentById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_PAYMENT_REQUEST });
    
      return axios.get(`/cash-payment/get/${id}`).then((response) => {
        dispatch({ type: CASH_PAYMENT_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoCashPayment = (bookId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear;

      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };

      if (bookId) {
        params = { ...params, bookId: bookId };
      }

      const response = await axios.get("/cash-payment/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const createCashPayment = (data, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear;

      dispatch({ type: CASH_PAYMENT_REQUEST });      

      return axios.post("/cash-payment/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_CASH_PAYMENT, payload: response.data });
        } else {
          dispatch({
            type: CASH_PAYMENT_REQUEST_FAILURE,
            error: "Cash Payment create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateCashPayment = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 

      return axios.put("/cash-payment/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Payment?.Company_Id || auth.company?.id,
            finyearId: data.Payment?.Finyear_Id || fin?.id,
            customerId: data.Payment?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_CASH_PAYMENT,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: CASH_PAYMENT_REQUEST_FAILURE,
            error: "Cash Payment update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteCashPayment = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: CASH_PAYMENT_REQUEST });
      const { auth } = getState();
      return axios.delete(`/cash-payment/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_CASH_PAYMENT, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { cashPayment: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getCashPaymentsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: CASH_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};